import { render, staticRenderFns } from "./FiltersDateRange.vue?vue&type=template&id=51495852"
import script from "./FiltersDateRange.vue?vue&type=script&lang=ts"
export * from "./FiltersDateRange.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports